import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { API_URL } from '../utils/api';

const ForgotPassword = ({ onNavigate }) => {
  const { print_lang } = useLanguage();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/admin/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <div className="auth-logo-icon" style={{ backgroundColor: '#10b981' }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>
            <h1 className="auth-logo-title">Check Your Email</h1>
            <p className="auth-logo-subtitle">Password reset instructions sent</p>
          </div>

          <div className="alert alert-success">
            If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
          </div>

          <div className="auth-links">
            <a href="#login" onClick={(e) => { e.preventDefault(); onNavigate('login'); }}>
              {print_lang('auth.backToLogin', 'Back to Login')}
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <h1 className="auth-logo-title">{print_lang('auth.forgotPassword', 'Forgot Password')}</h1>
          <p className="auth-logo-subtitle">Enter your email to reset password</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">{print_lang('auth.email', 'Email')}</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@example.com"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? print_lang('common.loading', 'Loading...') : print_lang('auth.sendResetLink', 'Send Reset Link')}
          </button>
        </form>

        <div className="auth-links">
          <a href="#login" onClick={(e) => { e.preventDefault(); onNavigate('login'); }}>
            {print_lang('auth.backToLogin', 'Back to Login')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
